import { EmptyState, ThemeProvider } from '@repo/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { queryClient } from '@/lib/query-client';
import { routes } from '@/routes/routes';
import { AppToaster } from '@/shared/components/AppToaster';
import { store } from '@/store/store';

const router = createBrowserRouter(routes);

export function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Suspense fallback={<EmptyState title="Loading…" />}>
            <RouterProvider router={router} />
          </Suspense>
          <AppToaster />
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  );
}
